import p5 from 'p5';
import Game from './Game';
new p5((engine) => {
    new Game(engine);
});
